import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { computed, defineComponent, ref, toRefs, watch, nextTick } from "@vue/composition-api";
import { uniqueId } from "lodash";
import BaseTextarea from "../base/base-textarea.vue";
import BaseLabel from "../base/base-label.vue";
import BaseFieldLayout from "../base/base-field-layout.vue";
export default defineComponent({
  name: "TextField",
  components: {
    BaseLabel,
    BaseFieldLayout,
    BaseTextarea
  },
  props: {
    value: {
      type: null,
      default: ""
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    sideGrid: {
      type: Boolean,
      default: false
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    },
    showMaxLengthLabel: {
      type: Boolean,
      default: true
    },
    maxLength: {
      type: Number,
      default: null
    },
    rows: {
      type: Number,
      default: 5
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    var _valueModel$value;
    const {
      value,
      showMaxLengthLabel,
      maxLength
    } = toRefs(props);
    const {
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      handleKeypressEnter,
      valueModel
    } = useCoreInput({
      value
    });
    const localValue = ref((_valueModel$value = valueModel == null ? void 0 : valueModel.value) != null ? _valueModel$value : "");
    watch(valueModel, newVal => {
      if (maxLength.value && showMaxLengthLabel.value && newVal.length > maxLength.value) {
        nextTick(() => {
          valueModel.value = newVal.substring(0, maxLength.value);
        });
      }
      localValue.value = valueModel.value;
    });
    const localValueLength = computed(() => {
      var _localValue$value$len, _localValue$value;
      return (_localValue$value$len = (_localValue$value = localValue.value) == null ? void 0 : _localValue$value.length) != null ? _localValue$value$len : 0;
    });
    const handleInput = event => {
      if (showMaxLengthLabel.value && maxLength.value) localValue.value = (event == null ? void 0 : event.target).value;
      handleBaseInput(event);
    };
    return {
      valueModel,
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      handleKeypressEnter,
      localValue,
      localValueLength,
      handleInput
    };
  }
});